import LineMapMarkerIcon from 'LuxKit/Icons/line/LineMapMarkerIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import BodyText from 'LuxKit/Typography/BodyText'
import PrintOnly from 'components/utils/PrintOnly'
import type { TripItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: TripItem
}

function PrintOnlyAddressAndNotes({ item }: Props) {
  const place =
    'startPlace' in item ?
      item.startPlace :
      'place' in item ?
        item.place :
        undefined

  return (
    <>
      {place?.address && (
        <PrintOnly>
          <BodyTextBlock variant="small" startIcon={<LineMapMarkerIcon />}>
            {place.address}
          </BodyTextBlock>
        </PrintOnly>
      )}
      {item.notes && (
        <PrintOnly>
          <BodyText variant="small" weight="normal" wrap="pre-wrap">
            {item.notes}
          </BodyText>
        </PrintOnly>
      )}
    </>
  )
}

export default PrintOnlyAddressAndNotes
